import { render } from "./ProdCategoriesListPage.vue?vue&type=template&id=d24b703c&ts=true"
import script from "./ProdCategoriesListPage.vue?vue&type=script&lang=ts"
export * from "./ProdCategoriesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__